module.exports = __webpack_public_path__ + "img/ИФ-1(А)-029.65a7c212.png";